import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NavLogin from 'components/navbar/NavLogin'
import loadable from '@loadable/component'
import styles from './styles/NavButtons.css'
import classNames from 'classnames'
import OrganizationLogo from '../misc/OrganizationLogo'
import { setTab, TABS } from '../../store/home/actions'

import authButtonStyles from './styles/NavLogin.css'

const NavDropdown = loadable(() => import('components/navbar/NavDropdown'))
const FeedDropdown = loadable(() => import('components/navbar/FeedDropdown'))

export const NavButtons = ({
  avatarBg = 'gray',
  buttonColor = 'transparent',
  staticPage,
  assistant = false,
  onMobileMenuClick
}) => {
  const user = useSelector(({ ui: { user } }) => user)
  const license = useSelector(({ ui }) => ui.organizationLicense)
  const navOpen = useSelector(({ ui: { navOpen } }) => navOpen)
  const dispatch = useDispatch()
  const [rendered, setRendered] = useState(false)
  const [renderOrgLogo, setRenderOrgLogo] = useState(false)

  useEffect(() => {
    setRendered(true)
  }, [])

  useEffect(() => {
    setRenderOrgLogo(!!user?.organizationLicense)
  }, [user])

  const showPricing = !user?.email && !(license?.licenseChecked && license?.hasLicense)

  const toolsItems = [
    { name: 'Features', section: true },
    {
      name: 'Assistant',
      href: '/assistant',
      onClick: () => dispatch(setTab(TABS.assistant)),
      icon: 'chat'
    },
    {
      name: 'Search',
      href: '/search',
      onClick: () => dispatch(setTab(TABS.search)),
      icon: 'search'
    },
    {
      name: 'Dashboards',
      href: '/users/me/dashboards',
      icon: 'dashboardLayout'
    },
    { name: 'All Features →', href: '/features', viewAll: true },
    { name: 'Integrations', section: true },
    {
      name: 'Scite MCP',
      href: '/mcp',
      icon: 'mcp'
    },
    {
      name: 'Scite API',
      href: 'https://api.scite.ai/docs',
      icon: 'api'
    },
    {
      name: 'Browser Extension',
      href: '/extension-install',
      icon: 'browserExtension'
    },
    { name: 'All Integrations →', href: '/integrations', viewAll: true },
    { name: 'Data', section: true },
    {
      name: 'Journals',
      href: '/journals',
      icon: 'journals'
    },
    {
      name: 'Organizations',
      href: '/affiliations',
      icon: 'organizations'
    },
    {
      name: 'Funders',
      href: '/institutions',
      icon: 'funders'
    },
    { name: 'All Data →', href: '/data', viewAll: true },
    showPricing && { name: 'Pricing', section: true },
    showPricing && {
      name: 'Plans & Pricing',
      href: '/pricing',
      icon: 'subscription'
    }
  ].filter(Boolean)

  return (
    <div className={styles.navButtons}>
      {rendered &&
        (onMobileMenuClick ? (
          <button className={styles.desktopHide} onClick={onMobileMenuClick}>
            <i className={styles.menuIcon} />
          </button>
        ) : (
          <NavDropdown
            className={styles.desktopHide}
            buttonColor={buttonColor}
            initialShow={navOpen}
            dropdownClassName={styles.linkItem}
            items={toolsItems}
            menuOffset={[-45, 26]}
            organizationLogo={user?.organizationLicense}
          >
            <i className={styles.menuIcon} />
          </NavDropdown>
        ))}
      <>
        {user?.email && <FeedDropdown />}
        {renderOrgLogo && (
          <OrganizationLogo slug={user?.organizationLicense} styles={classNames(styles.orgLogo, styles.mobileHide)} />
        )}
      </>

      <NavLogin
        avatarBg={avatarBg}
        buttonColor={buttonColor}
        showSignup={staticPage}
        avatarWrapperMobile={authButtonStyles.showAvatarWrapper}
        signupClassName={authButtonStyles.hideDesktopButton}
        loginClassName={authButtonStyles.hideDesktopButton}
      />
    </div>
  )
}

export default NavButtons
